import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Utils } from 'app/components/utils/Utils';
import { AppService } from 'app/services/app/app.service';
import { LanguageService } from 'app/services/language/language.service';
import { EventsService } from 'app/services/events/events.service';
import { RestService } from 'app/services/rest/rest.service';
import { combineLatest, Observable, Subject, takeUntil } from 'rxjs';
import { ModeEnum } from 'app/components/shared/offer-locker/offer-locker.component';
import { ItemCart, ParameterCart } from 'app/models/cart-model';
import { StepModel } from 'app/models/step-model';
import { Item, StockModel } from 'app/models/stock-model';
import { StockPromotionModel } from 'app/models/stock-promotion-model';
import { Log } from 'app/core/logging/log';


@Component({
    selector: 'app-locker-size',
    templateUrl: './locker-size.page.html',
    styleUrls: ['./locker-size.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LockerSizePage implements OnInit, OnDestroy {

  parameters: ParameterCart;
  sizes: Item[] = [];
  basePrices: StockPromotionModel;
  prices: StockPromotionModel;
  mode = ModeEnum.PRICE_SIZE;
  private destroy$ = new Subject<void>()
  
  private finished:boolean;

  constructor(
    private restService: RestService,
    public appService: AppService,
    private router: Router,
    private language: LanguageService,
    private route: ActivatedRoute,
    private eventsService: EventsService
  ) {}

  ngOnInit() {

    this.parameters = Utils.getParams(this.route.snapshot.queryParamMap);
    Log.debug('LockerSizePage::this.parameters', { parameters: this.parameters });

    combineLatest(
      {
        stock: this.appService.currentStock$,
        price: this.appService.currentPrice$
      } as {stock: Observable<StockModel>, price: Observable<StockPromotionModel>}
    ).pipe(takeUntil(this.destroy$))
    .subscribe({
      next:({ stock, price }) => {
        Log.debug('LockerSizePage::subscribe', { stock });

        this.sizes = Utils.getSizeLockerByType(stock, this.parameters.type);
        Log.debug('LockerSizePage::subscribe:stock:sizes', { sizes: this.sizes });

        const mode = Utils.getMode(stock, this.parameters);

        if(!this.skipByU(mode)){
          this.basePrices = price;
          this.prices = price;
          this.calculatorStep3();
        }
      }
    });

    this.eventsService.subscribe('callNext', result => {
      this.goCheckout();
    });
    
  }

  ngOnDestroy() {
    this.finished = true;
    this.eventsService.destroy('callNext');
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(){
    this.setNextBt(0)
  }
  
  callBack(data: ItemCart[]) {
    this.parameters = Utils.getParams(this.route.snapshot.queryParamMap, data);
    this.calculatorStep3();
  }

  setNextBt(total:number){
    if(this.finished){
      return;
    }
    let totalSrt = (total > 0) ? (' ' +  total + '€') : ' 0€';
    this.eventsService.publish('refreshStep', 
      { 
        title: "3/4", 
        nameBt: this.appService.getTraduccion('reserve.finish') + totalSrt,
        next: total > 0 
      } as StepModel);
  }

  goCheckout(){
    this.router.navigate([this.language.path('reserve'), this.appService.kiosk, 'checkout'], { queryParams: Utils.generateParams(this.parameters) });
  }

  msgError(error:any){
    if(error.code == 502){
      this.appService.showDangerToast(error.description);
      this.router.navigate([this.language.path()]);
    }
  }
  
  calculatorStep3(){
        const cartRequest = Utils.cartRequest(this.parameters);
        this.restService.calculatorStep3(cartRequest).subscribe((result:StockPromotionModel) => { 
          this.prices = Utils.deepMergePreserveOriginal(result, this.basePrices);
          Log.debug('LockerSizePage::merged', { prices: this.prices });
          this.setNextBt(this.prices.total);
        });
    }
  

  skipByU(mode:string){
    Log.debug('LockerSizePage::size', { sizes: this.sizes });
    if(mode == 'KEY'){
      let item = this.sizes[0];
      this.parameters.items = [
        {
            categoryId: item.id,
        }
      ];
    this.router.navigate([this.language.path('reserve'), this.appService.kiosk, 'checkout'], { queryParams: Utils.generateParams(this.parameters) });
      return true;
    }
    return false;
  }
  
}
